import axios from "axios";

const state = {
  dealerWait: null,
  isLoadingDealerWait: false,
  hasDealerWaitError: false,
  dealerWaitRequestId: 0,
  chargeTiers: []
};

const mutations = {
  START_DEALER_WAIT_REQUEST: (state) => {
    state.dealerWaitRequestId += 1;
    state.dealerWait = null;
    state.isLoadingDealerWait = true;
    state.hasDealerWaitError = false;
  },
  FINISH_DEALER_WAIT_REQUEST: (state, { dealerWait, hasError }) => {
    state.dealerWait = dealerWait;
    state.isLoadingDealerWait = false;
    state.hasDealerWaitError = hasError;
  },
  SET_CHARGE_TIERS: (state, data) => {
    state.chargeTiers = data;
  }
};

const actions = {
  async GET_DEALER_WAIT(context, data) {
    context.commit("START_DEALER_WAIT_REQUEST");
    const requestId = context.state.dealerWaitRequestId;
    const isLatestRequest = () => requestId === context.state.dealerWaitRequestId;

    try {
      const endpoint = process.env.VUE_APP_API_CATERINGV2;
      const response = await axios.get(`${endpoint}/dealer-wait-details`, { params: data });
      if (isLatestRequest()) {
        context.commit("FINISH_DEALER_WAIT_REQUEST", { dealerWait: response.data.detail, hasError: false });
      }
    } catch (e) {
      console.log(e);
      if (isLatestRequest()) {
        context.commit("FINISH_DEALER_WAIT_REQUEST", { dealerWait: null, hasError: true });
      }
    }
  },
  async GET_CHARGE_TIERS(context) {
    try {
      const endpoint = process.env.VUE_APP_API_CATERINGV2;
      const response = await axios.get(`${endpoint}/tardies-amounts`);
      context.commit("SET_CHARGE_TIERS", response.data.payload.results);
    } catch (e) {
      console.log(e);
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
